/**
 * Shared country data for phone input components
 * GCC countries prioritized at top for target market
 */

export interface Country {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
}

export const countries: Country[] = [
  // GCC Countries (prioritized)
  { code: 'ae', name: 'United Arab Emirates', dialCode: '+971', flag: '🇦🇪' },
  { code: 'sa', name: 'Saudi Arabia', dialCode: '+966', flag: '🇸🇦' },
  { code: 'qa', name: 'Qatar', dialCode: '+974', flag: '🇶🇦' },
  { code: 'om', name: 'Oman', dialCode: '+968', flag: '🇴🇲' },
  { code: 'bh', name: 'Bahrain', dialCode: '+973', flag: '🇧🇭' },
  { code: 'kw', name: 'Kuwait', dialCode: '+965', flag: '🇰🇼' },
  // MENA Region
  { code: 'eg', name: 'Egypt', dialCode: '+20', flag: '🇪🇬' },
  { code: 'jo', name: 'Jordan', dialCode: '+962', flag: '🇯🇴' },
  { code: 'lb', name: 'Lebanon', dialCode: '+961', flag: '🇱🇧' },
  { code: 'iq', name: 'Iraq', dialCode: '+964', flag: '🇮🇶' },
  // Asia
  { code: 'pk', name: 'Pakistan', dialCode: '+92', flag: '🇵🇰' },
  { code: 'in', name: 'India', dialCode: '+91', flag: '🇮🇳' },
  { code: 'sg', name: 'Singapore', dialCode: '+65', flag: '🇸🇬' },
  { code: 'my', name: 'Malaysia', dialCode: '+60', flag: '🇲🇾' },
  { code: 'ph', name: 'Philippines', dialCode: '+63', flag: '🇵🇭' },
  // Europe
  { code: 'gb', name: 'United Kingdom', dialCode: '+44', flag: '🇬🇧' },
  { code: 'de', name: 'Germany', dialCode: '+49', flag: '🇩🇪' },
  { code: 'fr', name: 'France', dialCode: '+33', flag: '🇫🇷' },
  { code: 'nl', name: 'Netherlands', dialCode: '+31', flag: '🇳🇱' },
  // Americas
  { code: 'us', name: 'United States', dialCode: '+1', flag: '🇺🇸' },
  { code: 'ca', name: 'Canada', dialCode: '+1', flag: '🇨🇦' },
  // Oceania
  { code: 'au', name: 'Australia', dialCode: '+61', flag: '🇦🇺' },
  // Africa
  { code: 'za', name: 'South Africa', dialCode: '+27', flag: '🇿🇦' },
  { code: 'ng', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬' },
  { code: 'ke', name: 'Kenya', dialCode: '+254', flag: '🇰🇪' },
];

export const DEFAULT_COUNTRY: Country = countries[0]!; // UAE
